/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/**
 * 活体认证弹出页
 */
import { Popup } from 'vant';
import { Component, Vue, Watch } from 'vue-property-decorator';

import LivenessPage from '@/components/liveness-page';
import { showLivenessSavePopup } from '@/components/liveness-save-popup';
import { useMaxQuotaText } from '@/shared/utils/getMaxQuota';

import { LivenessFromTypesEnum } from '@hb/liveness';
import type { LivenessSDKResultType } from '@hb/liveness';

import { LivenessSceneEnum } from '@/enums/liveness-param';
import { NativeVo } from '@/vo/Native';
import { session } from '@/shared/utils/storage';
import { setPageTitle } from '@/api/native/utils';
import { userActionTypeEnum } from '@/api/callBack/types';
import CallBackAPI from '@/api/callBack';
import UbtHelper from '@/shared/tools/ubtHelper';

const style = require('./index.module.scss') as Dictionary;

@Component({ name: 'LivenessPop' })
export default class LivenessPop extends Vue {
  public isOpen = false;

  // 响应式最高额度文案
  private maxQuotaText = useMaxQuotaText();

  private resolve!: PromiseResolve<string>;

  private reject!: PromiseReject;

  private ubtHelper = new UbtHelper('臻有钱_活体识别');

  private livenessParam!: NativeVo.LivenessParam

  private isSavePopupShowed = false;

  private h5BioSuc?: () => void;

  private get pageTitle(): string {
    return String(
      this.$route && this.$route.meta && this.$route.meta.title
        ? this.$route.meta.title
        : '',
    );
  }

  private get commodityId(): string {
    return this.livenessParam.commodityId || '';
  }

  public async open(
    params: NativeVo.LivenessParam,
    h5BioSuc?: () => void,
  ): Promise<string> {
    this.ubtHelper.enterPage();
    setPageTitle('人脸验证');

    this.livenessParam = params;
    this.h5BioSuc = h5BioSuc;

    this.isOpen = true;

    return new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  public close() {
    this.isOpen = false;
    this.isSavePopupShowed = false;

    if (this.reject) {
      this.reject(); // 如果已经resolve过了，再reject也没有关系
    }

    setPageTitle(this.pageTitle);
  }

  public save(): boolean {
    if (this.isSavePopupShowed) {
      this.close();

      return false;
    }

    const { scene } = this.livenessParam;

    if ([LivenessSceneEnum.Authority, LivenessSceneEnum.Apply].includes(scene)) {
      this.isSavePopupShowed = true;
      const title = scene === LivenessSceneEnum.Authority ? `只差一步！最高可借${this.maxQuotaText.value}` : '只差一步！立刻提现成功';
      showLivenessSavePopup(
        title,
        LivenessSceneEnum.Authority ? '授信环节' : '提现环节',
      ).catch(() => {
        this.close();
      }).finally(() => {
        this.isSavePopupShowed = false;
      });

      return true;
    }

    this.close();
    return false;
  }

  @Watch('isOpen')
  private onchange(val: boolean) {
    if (!val) {
      session.remove('suning');
    }
  }

  @Watch('$route')
  private onRouteChange() {
    this.close();
  }

  private onSuccess(result: LivenessSDKResultType) {
    const { transactionId, fromType } = result;
    if ([LivenessFromTypesEnum.BROWSERH5, LivenessFromTypesEnum.WEXINMPH5].includes(fromType)) {
      if (this.h5BioSuc) {
        this.h5BioSuc();
      }
    } else {
      const { scene } = this.livenessParam;
      // 当且仅当授信或者资料填写完成场景的活体认证 再去发起 用户运营事件上报
      if (scene === LivenessSceneEnum.Authority || scene === LivenessSceneEnum.MaterialSuccess) {
      // 新增 用户运营事件采集 -- 活体认证 scene 授信
        const params = {
          userAction: userActionTypeEnum.Liveness,
          scene,
        };
        CallBackAPI.userActionCallBack(params);
      }

      // 提现页面 活体认证成功埋点
      if (scene === LivenessSceneEnum.Apply) {
        this.$ubtPageButton(
          'finance_withdrawal_livingRecognitionSuccess',
          'commodityId',
          this.commodityId,
        );
      }
    }

    // 此处要先于reject前调用
    this.resolve(String(transactionId));
    this.close();
  }

  private onFail() {
    const { scene } = this.livenessParam;
    // 提现页面 活体认证失败埋点
    if (scene === LivenessSceneEnum.Apply) {
      this.$ubtPageButton(
        'finance_withdrawal_livingRecognitionFail',
        'commodityId',
        this.commodityId,
      );
    }
  }

  private render() {
    return (
      <Popup class={style.LivenessPopPage} v-model={this.isOpen} position="right">
        {
          (this.livenessParam && this.isOpen)
          && <LivenessPage
            scene={ this.livenessParam.scene }
            redirectUrl={ this.livenessParam.redirectUrl }
            commodityId={ this.commodityId }
            launchTransaction={ this.livenessParam.launchTransaction }
            skipAgreementCheck={ this.livenessParam.skipAgreementCheck }
            requestApiParams={{
              ocrComplete: this.livenessParam.ocrComplete,
              ocrAfterLoan: this.livenessParam.ocrAfterLoan,
            }}
            onSuccess={ this.onSuccess.bind(this) }
            onFail={ this.onFail.bind(this) }
          />
        }
      </Popup>
    );
  }
}
